var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatformOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23156_15763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8391 28.3928C17.5814 27.8188 12.4337 27.8188 7.17603 28.3928",
    stroke: "#9059FF",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9478 18.1454C27.6575 20.1885 26.004 21.7776 23.988 21.9596C17.9298 22.5064 12.0707 22.5064 6.01251 21.9596C3.99646 21.7776 2.34299 20.1885 2.05268 18.1454C1.45868 13.9649 1.45868 10.0119 2.05268 5.83147C2.34299 3.78832 3.99646 2.19913 6.01251 2.0172C12.0707 1.47046 17.9298 1.47046 23.988 2.0172C26.004 2.19913 27.6575 3.78832 27.9478 5.83147C28.5418 10.0119 28.5418 13.9649 27.9478 18.1454Z",
    fill: "#F4EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9478 18.1454C27.6575 20.1885 26.004 21.7776 23.988 21.9596C17.9298 22.5064 12.0707 22.5064 6.01251 21.9596C3.99646 21.7776 2.34299 20.1885 2.05268 18.1454C1.45868 13.9649 1.45868 10.0119 2.05268 5.83147C2.34299 3.78832 3.99646 2.19913 6.01253 2.0172C12.0707 1.47046 17.9298 1.47046 23.988 2.0172C26.004 2.19913 27.6575 3.78832 27.9478 5.83147C28.5418 10.0119 28.5418 13.9649 27.9478 18.1454Z",
    stroke: "#9059FF",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2882 22.3144C16.0939 22.3881 13.9095 22.3881 11.7151 22.3142L10.6892 28.0937C13.5702 27.9184 16.4327 27.9182 19.3137 28.0929L18.2882 22.3144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2887 22.3144C16.0944 22.3881 13.9099 22.3881 11.7156 22.3142L10.6897 28.0937C13.5707 27.9184 16.4332 27.9182 19.3141 28.0929L18.2887 22.3144Z",
    stroke: "#9059FF",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23156_15763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformOther);
export default __webpack_public_path__ + "static/media/platform_other.c713dce0adbe17e256579a7be678f822.svg";
export { ForwardRef as ReactComponent };